// extracted by mini-css-extract-plugin
export default {"modal_outer":"modal_modal_outer__qloR-","modal_inner":"modal_modal_inner__gMwME","modal_btn":"modal_modal_btn__xNz4a"};